// import VT from '@/store/types';

export default {
  // [VT.SAMPLES_LIST]: (state, { data, status }) => {
  //   state.samplesList = { data, status };
  // },
};
